export const dataLayerFormSubmit = (properties: {
  formName: string
  formStep?: string | number
  formValues: { [key: string]: unknown }
}): void => {
  ;(window as CustomWindow).dataLayer?.push({
    formValues: undefined
  })
  ;(window as CustomWindow).dataLayer?.push({
    event: 'form-submit',
    formStep: properties.formStep,
    formName: properties.formName,
    formValues: properties.formValues
  })
}

export const dataLayerVirtualPageViewEvent = () => {
  ;(window as CustomWindow).dataLayer?.push({
    event: 'virtualPageView'
  })
}
